<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.coupon") }}
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row">


                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="runningFrom"
                                    placeholder="หมายเลขเริ่มต้น"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="runningTo"
                                    placeholder="หมายเลขสิ้นสุด"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="orderId"
                                    placeholder="หมายเลขสั่งซื้อ"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="trackingNumber"
                                    placeholder="Tracking"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="phone"
                                    placeholder="เบอร์โทรที่ลงทะเบียน"
                                >
                                </base-input>
                            </div>


                            <div class="col-auto">
                                <base-button size="md" @click="handleSearch()">
                                    <i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button>
                                <!--
                                    "All" — spec 2026-09-23 §8.2/§8.3. Immediately after
                                    "ค้นหา" and gated on canCreateCouponEvent, the same
                                    config allowlist as the create/delete buttons; the
                                    server re-checks it inside CouponSearchAll and answers
                                    403 for anyone else, so this gate is cosmetic.
                                    @click (not .native) matches "ค้นหา" and Export beside it.
                                -->
                                <base-button v-if="canCreateCouponEvent" size="md" type="primary"
                                    :disabled="isAllLoading" @click="handleAll()">
                                    <i class="fas fa-spinner fa-spin " v-if="isAllLoading"></i>
                                    {{ $t("coupon_event.all") }}</base-button>
                                <base-button size="md" :loading="isLoading" :disabled="busy"
                                    @click="handleExport()" > Export</base-button>
                             </div>
                        </div>

                        <div class="row">
                            <div class="col mt-2">
                              Advance Search - Coupon ID : {{  head.id }}  -  {{  head.name }}
                              <!--
                                  §8.3's count. It is the ONLY thing on screen that tells the
                                  operator the table now holds the whole campaign rather than
                                  the first 1,000 rows — and Export writes whatever is in the
                                  table, so a truncated export is otherwise invisible.
                              -->
                              <span v-if="showAllCount" class="ml-2 font-weight-bold">
                                  · {{ $t("coupon_event.all_count", { n: tableData.length }) }}
                              </span>
                            </div>
                        </div>


                    </template>
                    <!-- end header -->

                    <div>
                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light">
                            <!-- order_number -->
                            <el-table-column align="left" :label="$t('number')" min-width="80px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.running_number }} </span>

                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <el-table-column align="left" :label="$t('order_id')" min-width="80px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.ID }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="ชื่อผู้สั่งซื้อ" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{  row.recipient_name }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="เบอร์โทรผู้สั่งซื้อ" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{  row.recipient_phone }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('tracking')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.shipping_tracking_number }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="ชื่อผู้ลงทะเบียน" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.member_fname }}  {{  row.member_lname }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="เบอร์โทรผู้ลงทะเบียน" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.member_phone }} </span>
                                </div>
                            </el-table-column>

                            <!-- <el-table-column align="left" :label="$t('date')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.updated_at }} </span>
                                </div>
                            </el-table-column> -->





                            <el-table-column align="right" :label="$t('actions')" min-width="120px">
                                <div slot-scope="{ $index, row }" class="d-flex">

                                    <base-button @click.native="
                                        handleDetail(row)
                                        " class="edit" type="warning" size="sm" icon>
                                        <i class="text-dtac-bt fa fa-list"></i>
                                    </base-button>

                                    <!-- <base-button
                                        @click.native="handleChangeQRCode(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fas fa-edit"></i>
                                    </base-button>


                                    <base-button @click.native=" handleClearQR($index, row)" class="btn-link"
                                        type="danger" size="sm" icon >
                                        <i class="text-white fas fa-trash"></i>
                                    </base-button> -->
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0">
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>

            <!--
                The blocking modal while "All" loads (§8.3, the same pattern as
                ReportProductCost.vue). It has no way out on purpose: the three
                no-close props mean the ONLY thing that hides it is `busy` going
                false, which happens in a finally — success or error. Without it
                the operator sees the old table during a request that can take
                tens of seconds over 100k rows, and presses Export on the STALE
                contents.
            -->
            <el-dialog
                :visible.sync="busy"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                :modal-append-to-body="true"
                append-to-body
                center
                width="280px"
            >
                <div class="text-center py-2">
                    <i class="el-icon-loading" style="font-size: 32px"></i>
                    <!-- The label names which of the two long jobs is running;
                         "All" over an export would read as the wrong one. -->
                    <div class="mt-3">{{ busyLabel }}</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Dialog } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import FileInput from "@/components/Inputs/FileInput";
import { undistributeHeight } from '@fullcalendar/core';
import { read, utils, writeFile } from 'xlsx'
import {
    couponEventErrorI18nKeyFor,
    couponAllParams
} from "@/utils/couponEvent";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dialog.name]: Dialog
    },
    computed: {
        ...mapGetters({
            tableData: "Coupon/getDataDetail",
            isLoading: "Coupon/isLoading",
            OrderStatusTable: "Order/OrderStatusTableWithAll",

            isAdmin: "Auth/isAdmin",
            isOwner: "Auth/isOwner",
            isEmployee: "Auth/isEmployee",
            isAgent: "Auth/isAgent",
            // The Auth module is namespaced — same plumbing as the create and
            // delete buttons on CouponTables.vue.
            canCreateCouponEvent: "Auth/canCreateCouponEvent",
        }),

        // The count is shown only after an "All" load, never after an ordinary
        // search: on a limited search the number would be "how many the LIMIT
        // let through", which reads as a fact about the campaign and is not one.
        showAllCount() {
            return this.allLoaded && this.tableData.length > 0;
        },
    },
    watch: {
        runningFrom: {
            handler(newValue, oldValue) {
                this.runningTo = newValue
            },
            deep: true,
        },
    },
    data() {
        return {
            propsToSearch: ["running_number", "code"],
            selectedRows: [],
            orderId: "",
            trackingNumber : "",
            runningNumber : "",
            runningFrom : "",
            runningTo : "",
            headId : "",
            phone : "",
            head: {},
            // `busy` drives the blocking modal; `isAllLoading` only disables the
            // button. Two flags rather than one because the modal must also be
            // raised by nothing else on this screen (§8.3).
            busy: false,
            // Which job the modal is covering. Both are long enough that the
            // operator needs to know which one they are waiting on.
            busyLabel: "",
            isAllLoading: false,
            // True only while the table holds an "All" result. Any ordinary
            // search clears it, so the count label can never describe a table it
            // is not looking at.
            allLoaded: false,
        };
    },
    async mounted() {

        this.clearDataDetail();
        this.headId = this.$route.params.id

        if (this.headId == "" ) {
            this.$router.push("/backoffice/coupon");
        }

        try {

            const resp = await this.getData({id: this.headId});
            this.head = resp.data.Datum
        }
        catch (error) {
            console.log(error);
            // this.$router.push("/backoffice/coupon");
        }

    },
    methods: {
        ...mapActions({
            listData: "Coupon/listDataDetailAll",
            listDataAll: "Coupon/listDataDetailAllStrict",
            getData: "Coupon/getData",
            clearDataDetail: "Coupon/clearDataDetail",
        }),

        // handleAll — spec 2026-09-23 §8.2/§8.3.
        //
        // Loads EVERY code of this event into the same table the ordinary search
        // fills, so Export (handleExport, which writes `tableData` as-is) then
        // contains the whole campaign. The running-range boxes are ignored on
        // purpose — see couponAllParams.
        //
        // The blocking modal is not decoration: 100,000 rows is the documented
        // ceiling (§8.2), the request takes as long as it takes, and the table
        // still shows the PREVIOUS result while it runs. Without the modal the
        // obvious thing to do is press Export on the stale contents.
        async handleAll() {
            if (this.isAllLoading || this.busy) return;

            this.isAllLoading = true;
            this.busyLabel = this.$t("coupon_event.all_loading");
            this.busy = true;
            this.allLoaded = false;
            try {
                await this.listDataAll(couponAllParams(this.headId));
                this.pagination.currentPage = 1;
                this.allLoaded = true;
                // Keep the modal up until Vue has flushed the tableData watcher.
                //
                // The cost there is NOT the Fuse index — Fuse v3 builds its
                // index lazily at search time and this screen has no search box,
                // so initSearch's constructor is about a millisecond. It is
                // Vue's reactivity walk over the committed rows, which is why
                // the store freezes them (coupon_module.js
                // listDataDetailAllStrict). With that in place this tick is
                // cheap, and it is kept because the flush still has to happen
                // before the table paints: dropping the modal first would hand
                // the operator a screen that is still showing the previous
                // result.
                await this.$nextTick();
            } catch (err) {
                const status = (err && err.response && err.response.status) || 0;
                const data = (err && err.response && err.response.data) || {};
                swal.fire({
                    title: this.$t(
                        status === 403
                            ? "coupon_event.errors.coupon_event_forbidden"
                            // unknown_all, not unknown: this button loads, it
                            // does not create, and the generic sentence names
                            // the wrong verb.
                            : couponEventErrorI18nKeyFor(data.Msg, "unknown_all")
                    ),
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            } finally {
                // One finally for both flags: a path that left `busy` up would
                // leave the operator with a modal that has no close button.
                this.busy = false;
                this.isAllLoading = false;
            }
        },
        handleSearch() {

            try {

                if (this.runningTo != "" && this.runningFrom != "")
                {
                    let runningFromInt = parseInt(this.runningFrom)
                    let runningToInt = parseInt(this.runningTo)

                    if (runningFromInt > runningToInt) {
                        swal.fire({
                            title: "Error",
                            text: "หมายเลขเริ่มต้นต้องน้อยกว่าหมายเลขสิ้นสุด",
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                        return
                    }

                    // range must be less than 10000
                    if (runningToInt - runningFromInt > 10000) {
                        swal.fire({
                            title: "Error",
                            text: "หมายเลขสิ้นสุดต้องน้อยกว่าหมายเลขเริ่มต้นไม่เกิน 10000",
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                        return
                    }
                }

                this.pagination.currentPage = 1;
                // An ordinary search replaces an "All" result, so the count
                // label must stop claiming the table holds everything.
                this.allLoaded = false;
                const params = {
                    head_id: this.headId,
                    running_from: this.runningFrom,
                    running_to: this.runningTo,
                    phone : this.phone,
                    order_id : this.orderId,
                    tracking_number : this.trackingNumber,
                }
                this.listData(params);
            }

            catch (error) {
                swal.fire({
                    title: "Error",
                    text: "กรุณากรอกหมายเลขให้ถูกต้อง",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                console.log(error);
            }

            // const params = {
            //     head_id: this.headId,
            //     running_from: this.runningFrom,
            //     running_to: this.runningTo,
            // }
            // this.listData(params);
        },
        // Export raises the SAME blocking modal as "All".
        //
        // json_to_sheet + writeFile over 100k rows is tens of seconds of
        // synchronous main-thread work with no event loop in between: the tab
        // simply stops responding, the button does not even repaint as pressed,
        // and the operator's reasonable conclusion is that the click was
        // missed — so they click again and start a second one. The modal is
        // raised, the browser is given one tick to actually paint it, and only
        // then does the work start.
        async handleExport(){
            if (this.busy) return;
            this.busyLabel = this.$t("coupon_event.exporting");
            this.busy = true;
            await this.$nextTick();
            try {
                this.buildExport();
            } finally {
                this.busy = false;
            }
        },
        buildExport(){
            // let i = 1
			// let dataExport = this.tableData.map((v) => {
			// 	return {
			// 	NO: i++,
			// 	CouponNumber: v.coupon_number,
			// 	CouponCode: v.coupon_code,
			// 	Address: v.address,
			// 	SubDistrict: v.subdistrict,
			// 	Distrcit: v.district,
			// 	Province: v.province,
			// 	PHone: v.phone,
			// 	Firstname: v.fname,
			// 	Lastname: v.lname,
			// 	TrackingNumber: v.tracking_number,
			// 	}

			// })
			const dataWS = utils.json_to_sheet(this.tableData)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'export_coupon_admin.xlsx')

        },
        handleDetail(row) {
            // swal show row.url

            swal.fire ({
                title: 'Coupon Detail',
                html: `
                    <div class="row text-left">
                        <div class="col-4">หมายเลขคูปอง</div>
                        <div class="col-8">${row.running_number}</div>
                    </div>
                    <hr />
                    <h5>ข้อมูลการสั่งซื้อ</h5>
                    <div class="row text-left">
                        <div class="col-4">หมายเลขสั่งซื้อ</div>
                        <div class="col-8">${row.ID}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">หมายเลขพัสดุ</div>
                        <div class="col-8">${row.shipping_provider_name} : ${row.shipping_tracking_number}</div>
                    </div>

                    <div class="row text-left">
                        <div class="col-4">ชื่อ</div>
                        <div class="col-8">${row.recipient_name}</div>
                    </div>

                    <div class="row text-left">
                        <div class="col-4">เบอร์โทรศัพท์</div>
                        <div class="col-8">${row.recipient_phone}</div>
                    </div>

                    <div class="row text-left">
                        <div class="col-4">ที่อยู่</div>
                        <div class="col-8">${row.recipient_address_fulladdress}</div>
                    </div>

                    <div class="row text-left">
                        <div class="col-4">Platform</div>
                        <div class="col-8">${this.getPlatfrom(row)}</div>
                    </div>

                    <div class="row text-left">
                        <div class="col-4">สถานะ</div>
                        <div class="col-8">${this.GetOrderStatus(row.order_status)}</div>
                    </div>


                    <hr />
                    <h5>ข้อมูลการลงทะเบียน</h5>
                    <div class="row text-left">
                        <div class="col-4">ชื่อ - สกุล</div>
                        <div class="col-8">${row.member_fname} ${row.member_lname}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">เบอร์โทรศัพท์</div>
                        <div class="col-8">${row.member_phone}</div>
                    </div>

                    <div class="row text-left">
                        <div class="col-4">URL</div>
                        <div class="col-8">${row.qr_text}</div>
                    </div>
                `,
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
            })


        },
        getPlatfrom(row){

            // let result = "MadameFin"
            // switch (row.platfrom_id) {
            //     case 2: result = "Tiktok"; break;
            //     case 3: result = "Shopee"; break;
            //     case 4: result = "Lazada"; break;
            //     case 5: result = "Line"; break;
            // }

            let result = "-"
            if (row.platform_id == 1) {
                result =  "MadameFin"
            } else if (row.platform_id == 2) {
                result = "Tiktok : " + row.platform_order_id
            } else if ( row.platform_id == 3) {
                result = "Shopee : " + row.platform_order_id
            } else if ( row.platform_id == 4) {
                result = "Lazada : " + row.platform_order_id
            } else if ( row.platform_id == 5) {
                result = "Line : " + row.platform_order_id
            } else if ( row.platform_id == 9) {
                result = "MDFStore"
            }

            return result
        },



        handleCreate() {
            this.$router.push("/backoffice/po/create");
        },
        GetOrderStatus(id) {
            switch (id)
            {
                case 100 :return `<span class="btn btn-sm"> ${ this.$t("order_status_unpaid")}</span>`
                case 111 :return `<span class="btn btn-info btn-sm"> ${ this.$t("order_status_awaiting_shipment") } </span>`
                case 112 :return `<span class="btn btn-info btn-sm"> ${ this.$t("order_status_awaitingcollection") } </span>`
                case 114 :return `<span class="btn btn-info btn-sm"> ${ this.$t("order_status_partiallyshipping") } </span>`
                case 115 :return `<span class="btn btn-info btn-sm"> ${ this.$t("order_status_awaiting_transit") } </span>`
                case 121 :return `<span class="btn btn-primary btn-sm"> ${ this.$t("order_status_intransit") } </span>`
                case 122 :return `<span class="btn btn-primary btn-sm"> ${ this.$t("order_status_delivered") } </span>`
                case 130 :return `<span class="btn btn-success btn-sm"> ${ this.$t("order_status_completed") } </span>`
                case 140 :return `<span class="btn btn-danger btn-sm"> ${ this.$t("order_status_cancelled") } </span>`
                case 141 :return `<span class="btn btn-danger btn-sm"> ${ this.$t("order_status_returned") } </span>`
                case 142 :return `<span class="btn btn-danger btn-sm"> ${ this.$t("order_status_claimed") } </span>`
                case 143 :return `<span class="btn btn-warning btn-sm"> ${ this.$t("order_status_returning") } </span>`
            }
            return result != null ? result.Name : "-";
        },

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
